var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M946.432 829.226667L530.922667 32.768c-7.36-14.08-30.485333-14.08-37.845334 0L354.133333 299.093333c2.837333-0.192 5.653333-0.426667 8.533334-0.426666a128 128 0 1 1 0 256 127.786667 127.786667 0 0 1-109.525334-61.994667l-175.573333 336.533333a21.376 21.376 0 0 0 9.237333 28.906667C219.584 925.717333 362.645333 960 512 960s292.416-34.282667 425.194667-101.888a21.376 21.376 0 0 0 9.237333-28.885333z",
    fill: "#EA9860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.666667 554.666667a128 128 0 1 0 0-256c-2.88 0-5.696 0.234667-8.533334 0.426666l-100.992 193.578667A127.786667 127.786667 0 0 0 362.666667 554.666667z",
    fill: "#C94F49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 640m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z",
    fill: "#C94F49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 1002.666667c-156.16 0-305.706667-35.84-444.565333-106.538667a64 64 0 0 1 58.090666-114.090667C246.186667 843.52 376.234667 874.666667 512 874.666667s265.792-31.146667 386.474667-92.629334a64 64 0 1 1 58.090666 114.090667C817.706667 966.805333 668.138667 1002.666667 512 1002.666667z",
    fill: "#DDBE99"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.8f3e40970a4b6b940cb164d7672bb512.svg";
export { ForwardRef as ReactComponent };